import { render, staticRenderFns } from "./PackagesGridFilters.vue?vue&type=template&id=376ecb0f&scoped=true"
import script from "./PackagesGridFilters.vue?vue&type=script&lang=js"
export * from "./PackagesGridFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "376ecb0f",
  null
  
)

export default component.exports